import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Import your components
import Navbar from './Components/Navbar/Navbar';
import LandingPage from './Components/LandingPage/LandingPage';
import Tender from './Components/Tender/Tender'; // Adjust this path if your folder structure is different

function App() {
  return (
    <Router>
      <div className="App">
        {/* Navbar sits outside of Routes so it stays visible on all pages */}
        <Navbar /> 
        
        <Routes>
          {/* Define your page paths here */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/szechenyi-terv-plusz" element={<Tender />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;